 import { makeStyles } from '@material-ui/core';

const useErrorMessageStyles = makeStyles({
    error__message: {
      color: 'var(--light-venetian-red)',
      fontSize: '11px'
    }
  });

export default useErrorMessageStyles;